const { fetchAuthorizedJsonApi, fetchJsonApi } = require('./abstract');
const { getApiLanguage } = require('./language');

/**
 * @return Promise that returns all purchases of the logged in user.
 */
function fetchPurchase(apiUrl, token, purchaseId) {
  if (!purchaseId) {
    return Promise.reject(new Error('Missing purchaseId'));
  }

  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'GET',
    endpoint: `v1/purchases/${purchaseId}`,
    query: { lang: getApiLanguage() },
    expectedStatus: 200,
    description: 'Fetching purchase',
  });
}

/**
 * @return Promise that returns all purchases of the logged in user.
 */
function fetchPurchases(apiUrl, token) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'GET',
    endpoint: 'v1/purchases',
    query: { lang: getApiLanguage() },
    expectedStatus: 200,
    description: 'Fetching purchases',
  });
}

function setCardsSeen(apiUrl, token, purchaseId) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'PUT',
    endpoint: `v1/purchases/${purchaseId}/seen`,
    expectedStatus: 200,
    description: 'Opening purchase',
  });
}

function openPurchase(apiUrl, token, purchaseId) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'PUT',
    endpoint: `v4/purchases/${purchaseId}/open`,
    expectedStatus: 200,
    description: 'Opening purchase',
  });
}

function updateIap(apiUrl, token, purchaseId, updateDetails) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'PUT',
    endpoint: `v1/purchases/${purchaseId}`,
    body: updateDetails,
    expectedStatus: 200,
    description: 'Update in-app purchase',
  });
}

function fetchPaymentSystems(apiUrl, country) {
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: 'v2/purchases/payment-systems',
    query: { country },
    expectedStatus: 200,
    description: 'Fetching payment systems',
  });
}

function fetchSkrillPaymentMethods(apiUrl, country) {
  return fetchJsonApi({
    apiUrl,
    method: 'GET',
    endpoint: 'v1/purchases/skrill/payment-methods',
    query: { country },
    expectedStatus: 200,
    description: 'Fetching skrill payment methods',
  });
}

function createPurchase(apiUrl, token, data) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'POST',
    endpoint: 'v1/purchases',
    query: { lang: getApiLanguage() },
    body: data,
    expectedStatus: 200,
    description: 'Creating purchase',
  });
}

function tradePremiumCard(apiUrl, token, purchaseId) {
  return fetchAuthorizedJsonApi({
    apiUrl,
    token,
    method: 'PUT',
    endpoint: `v1/purchases/${purchaseId}/trade`,
    expectedStatus: 200,
    description: 'Trading premium card for diamonds',
  });
}

module.exports = {
  fetchPurchase,
  fetchPurchases,
  fetchPaymentSystems,
  setCardsSeen,
  openPurchase,
  createPurchase,
  updateIap,
  tradePremiumCard,
  fetchSkrillPaymentMethods,
};
